<template>
    <div>
       <!-- <pdf :src="url" :hidden="!success"  />
-->
        <div class="water-print" :hidden="success">
            <a-spin tip="正在下载文件..." :spinning="spinning" size="large" style="padding-top: 100px" >

            </a-spin>

            <a-result
                    v-if="warning"
                    status="warning"
                    title="加载失败"
                    sub-title="请确认单号是否存在,或稍后尝试刷新或重新打开页面"
            >
            </a-result>
        </div>
    </div>

</template>

<script>
    import {files} from '@/http';
    export default {
        name: "print",
        data(){
            return {
                spinning:true,
                warning:false,
                success:false,
                url:'',
                numPages:0
            };
        },

        created(){
            files('/health/sdbao/print/generate/'+this.$route.query.policyNo,{
                noTips:true
            })
                .then((data)=>{

                    window.location.href = '/health/sdbao/print/generate/'+this.$route.query.policyNo;


                    this.spinning = false;
                    this.success = true;
                })
                .catch(()=>{
                    this.spinning = false;
                    this.warning = true;
                });
        },
        methods:{
            jump(){
                window.location.href = this.url;
            }
        }
    };
</script>

<style scoped>
    .water-print{
        left: 0;
        top:0;
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: #e6f7ff;
        padding-top: 200px;
        text-align: center;
    }


</style>
